export default __webpack_public_path__ + "src/assets/OpenX_logo.png";